import { IColumnDefinition } from "@common/models/column-definition";

export class ListerColumnConfig {
    ListerName: string;
    ColumnConfig: ColumnConfigControlItem[];
}
  
export class ColumnConfigControlItem {
    ColDef: IColumnDefinition;
    Allowed: boolean;
    Default: boolean;
}

export class ProductListerConfigDto {
    Name: string;
    Product: string;
    DefaultListerColumns: string[];
    AllowedListerColumns: string[];
}